var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85718 2C9.30489 2 8.85718 2.44772 8.85718 3V9H2.85718C2.30489 9 1.85718 9.44772 1.85718 10C1.85718 10.5523 2.30489 11 2.85718 11H8.85718V17C8.85718 17.5523 9.30489 18 9.85718 18C10.4095 18 10.8572 17.5523 10.8572 17V11H16.8572C17.4095 11 17.8572 10.5523 17.8572 10C17.8572 9.44772 17.4095 9 16.8572 9H10.8572V3C10.8572 2.44772 10.4095 2 9.85718 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7b762f4200cbf77f85b9b392e22fc643.svg";
export { ForwardRef as ReactComponent };